import { useEffect } from 'react';
import styled from 'styled-components';

const IFrameContainer = styled.div`
    width: 100%;
    height: 100%;
    min-width: 20rem;
    min-height: 30rem;
    max-height: 41.5rem;

    iframe {
        min-height: 41.5rem;
        width: 100%;
        border: 0;
    }
`;

const HubSpotFormMeeting = () => {
  useEffect(() => {
    if (!window.hbspt || !window.hbspt.meetings) {
      const script = document.createElement('script');

      const onScriptLoad = () => {
        script.removeEventListener('load', onScriptLoad);
      };

      script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      script.type = 'text/javascript';

      script.addEventListener('load', onScriptLoad);
      document.body.appendChild(script);

      return () => {
        script.removeEventListener('load', () => {});
        document.body.removeChild(script);
      };
    }

  }, []);
  return (
    <IFrameContainer>
        <iframe
            title={'Schedule a meeting'}
            src={'https://meetings.hubspot.com/archvision/archvision-l-fovea-demo?embed=true'}
        />
    </IFrameContainer>
  );
};

export { HubSpotFormMeeting };
